<template>
    <b-navbar class="navbar is-dark" :fixed-top="false" :active="false">
        <template #brand>
            <router-link to="/">
                <div class="image is-48x48">
                    <b-image src="/images/rjd-logo.png" responsive/>
                </div>
            </router-link>
        </template>
        <template #start>
            <b-navbar-item v-if="isVisibleStudentMenu" tag="router-link" :to="{name: 'tests.index'}">
                <b-icon icon="chart-bar" size="is-small"/>
                <span class="ml-1">Протоколы</span>
            </b-navbar-item>
            <b-navbar-item v-if="isVisibleStudentMenu"  tag="router-link" :to="{name: 'tickets.index'}">
                <b-icon icon="book-open-outline" size="is-small"/>
                <span class="ml-1">Обучение</span>
            </b-navbar-item>
            <b-navbar-item v-if="isVisibleStudentMenu"  :href="applicationLink" target="_blank">
                <b-icon icon="book-open-outline" size="is-small"/>
                <span class="ml-1">Анкета</span>
            </b-navbar-item>




        </template>
        <template #end>
            <b-navbar-dropdown v-if="isVisibleEngineerMenu || isVisibleAdminMenu">
                <template #label>
                    <b-icon icon="cog" size="is-small"></b-icon>
                    <span class="ml-1">Инструменты</span>
                </template>
                <b-navbar-item v-if="isVisibleEngineerMenu" tag="router-link" :to="{name: 'users'}">
                    <b-icon icon="account-group" size="is-small"/>
                    <span class="ml-1">Пользователи</span>
                </b-navbar-item>
                <b-navbar-item v-if="isVisibleEngineerMenu" tag="router-link" :to="{name: 'groups'}">
                    <b-icon icon="account-group" size="is-small"/>
                    <span class="ml-1">Группы</span>
                </b-navbar-item>
                <b-navbar-item v-if="isVisibleEngineerMenu || isVisibleAdminMenu" tag="router-link"
                               :to="{name: 'applications.cpo-approving'}">
                    <b-icon icon="application-cog" size="is-small" />
                    <span class="ml-1">Заявки</span>
                </b-navbar-item>
                <b-navbar-item v-if="isVisibleEngineerMenu || isVisibleAdminMenu" tag="router-link"
                               :to="{name: 'organizations.stats'}">
                    <b-icon icon="chart-areaspline" size="is-small"/>
                    <span class="ml-1">Статистика по цпо</span>
                </b-navbar-item>
                <b-navbar-item v-if="isVisibleEngineerMenu || isVisibleAdminMenu" tag="router-link" :to="{name: 'knowledges'}">
                    <b-icon icon="book-open-page-variant" size="is-small"/>
                    <span class="ml-1">Объём знаний</span>
                </b-navbar-item>
                <b-navbar-item v-if="isVisibleEngineerMenu || isVisibleAdminMenu" tag="router-link" :to="{name: 'education-plan'}">
                    <b-icon icon="calendar-edit" size="is-small"/>
                    <span class="ml-1">Билеты</span>
                </b-navbar-item>
                <b-navbar-item v-if="isVisibleEngineerMenu || isVisibleAdminMenu" tag="router-link" :to="{name: 'share.education-plans.index'}">
                    <b-icon icon="monitor-share" size="is-small"/>
                    <span class="ml-1">Входящие</span>
                </b-navbar-item>




            </b-navbar-dropdown>

            <b-navbar-dropdown right>
                <template #label v-if="currentUser">
                    <div class="image is-24x24 mr-1 ">
                        <b-image :src="currentUser.photoPath" ratio="1by1" rounded responsive/>
                    </div>
                    <span>{{ currentUser.fullName }}</span>
                </template>

                <b-navbar-item value="info" aria-role="menuitem" tag="div">
                    <div class="ml-1" v-if="userRoles.length <= 1">
                        Роль:
                        <b-tooltip
                            :label="roleNames"
                            position="is-left"
                            type="is-dark"
                            size="is-large"
                            multilined
                            :active="roleNames.length > 35"
                        >
                            <b>{{roleNames | cutText(35)}}</b>
                        </b-tooltip>
                    </div>
                    <div v-else>
                        <multiselect
                            :allow-empty="false"
                            v-model="currentRole"
                            :options="userRoles"
                            @select="roleSelect"
                            label="name"
                            trackBy="id"
                            placeholder="Роль"
                            selectLabel="Нажмите ввод чтобы выбрать"
                            deselectLabel="Нажмите ввод чтобы снять выбор"
                            selectedLabel="Выбраный"
                            style="min-width: 400px"
                        />
                    </div>
                </b-navbar-item>
                <b-navbar-item value="info" aria-role="menuitem" tag="div">
                    <div class="ml-1" v-if="userOrganizations.length <= 1">
                        Организация:
                        <b-tooltip

                            position="is-left"
                            type="is-dark"
                            size="is-large"
                            multilined
                        >
                            <template #content>
                                <div v-if="isLoaderActive('organizations.fetchItems')" >
                                    <b-loading :active="true" />
                                </div>
                                <span>{{organizationFullPath}}</span>
                            </template>
                            <b @mouseover="openOrgTooltip">{{organizationNames | cutText(35)}}</b>
                        </b-tooltip>
                    </div>
                    <div v-else>
                        <multiselect
                            :allow-empty="false"
                            v-model="currentOrganization"
                            :options="userOrganizations"
                            @select="organizationSelect"
                            label="name"
                            trackBy="id"
                            placeholder="Огранизация"
                            selectLabel="Нажмите ввод чтобы выбрать"
                            deselectLabel="Нажмите ввод чтобы снять выбор"
                            selectedLabel="Выбраный"
                            style="min-width: 400px"
                        />
                    </div>
                </b-navbar-item>
                <b-navbar-item v-if="userPositions.length !== 0" value="info" aria-role="menuitem" tag="div">
                    <div class="ml-1" v-if="userPositions.length <= 1">
                        Должность:
                        <b-tooltip
                            :label="positionNames"
                            position="is-left"
                            type="is-dark"
                            size="is-large"
                            multilined
                            :active="positionNames.length > 35"
                        >
                            <b>{{positionNames | cutText(35)}}</b>
                        </b-tooltip>
                    </div>
                    <div v-else>
                        <multiselect
                            :allow-empty="false"
                            v-model="currentPosition"
                            :options="userPositions"
                            @select="positionSelect"
                            label="name"
                            trackBy="id"
                            placeholder="Должность"
                            selectLabel="Нажмите ввод чтобы выбрать"
                            deselectLabel="Нажмите ввод чтобы снять выбор"
                            selectedLabel="Выбраный"
                            style="min-width: 400px"
                        />
                    </div>
                </b-navbar-item>
                <hr class="dropdown-divider">
                <b-navbar-item value="account" aria-role="menuitem" tag="a" target="_blank" :href="userProfileUrl">
                    <b-icon icon="account"/>
                    <span class="ml-1">Профиль</span>
                </b-navbar-item>
                <b-navbar-item value="settings" aria-role="menuitem" tag="router-link" :to="{name: 'settings.index'}">
                    <b-icon icon="cog"></b-icon>
                    <span class="ml-1">Настройки</span>
                </b-navbar-item>
                <hr class="dropdown-divider">
                <b-navbar-item @click.prevent="doLogout" aria-role="menuitem">
                    <b-icon icon="logout"></b-icon>
                    <span class="ml-1">Выйти</span>
                </b-navbar-item>
            </b-navbar-dropdown>
        </template>
        <template #burger="{isOpened, toggleActive}">
            <a @click="toggleActive" class="navbar-burger burger" :class="{'is-active': !!isOpened}">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </template>
    </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getUserProfileURL } from '../../constants/urls'
import { cloneDeep, filter, find, get, includes, map, orderBy, uniq, uniqBy } from 'lodash'
import { ADMIN, ENGINEER, STUDENT } from '../../store/models/roles/model'

import OrganizationFetchMixin from '../../mixins/OrganizationFetchMixin'

export default {
    mixins: [
        OrganizationFetchMixin
    ],
    data() {
        return {
            currentRole: null,
            currentOrganization: null,
            currentPosition: null,
        }
    },
    mounted () {
        if (this.currentUserRoleId) {

            let role = find(this.userRoles, item => get(item, 'id') === this.currentUserRoleId)
            if (!role) {
                role = get(this.userRoles, '0')
                if (role) this.setCurrentUserRoleId(role.id)
            }
            this.currentRole = role
        } else {
            let role = get(this.userRoles, '0')
            if (role) this.setCurrentUserRoleId(role.id)
        }
        this.$nextTick(()=>{
            if (this.currentOrganizationId) {
                let org = find(this.userOrganizations, item => get(item, 'id') === this.currentOrganizationId)
                if (!org) {
                    org = get(this.userOrganizations, '0')
                    if (org) this.setCurrentOrganizationId(org.id)
                }
                this.currentOrganization = org
            } else {
                let pos = get(this.userOrganizations, '0')
                if (pos) this.setCurrentOrganizationId(pos.id)
            }
        })
        this.$nextTick(()=>{
            if (this.currentPositionId) {
                let pos = find(this.userPositions, item => get(item, 'id') === this.currentPositionId)
                if (!pos) {
                    pos = get(this.userPositions, '0')
                    if (pos) this.setCurrentPositionId(pos.id)
                }
                this.currentPosition = pos
            } else {
                let pos = get(this.userPositions, '0')
                if (pos) this.setCurrentPositionId(pos.id)
            }
        })
    },
    methods: {
        ...mapActions({
            logout: 'e/users/logout',
            setCurrentUserRoleId: 'e/users/setCurrentUserRoleId',
            setCurrentOrganizationId: 'e/users/setCurrentOrganizationId',
            setCurrentPositionId: 'e/users/setCurrentPositionId',
            toggleSideBar: 'e/pages/toggleSideBar',
        }),
        doLogout () {
            this.logout().then(() => this.$router.push({ name: 'auth.login' }))
        },
        filterItems(key, predicate) {
            return uniqBy(
                filter(map(
                    filter(
                        get(this.currentUser, 'currentRoles', []), predicate
                    ),
                    key
                ), item => !!item),

        'id')
        },
        roleSelect(value) {
            if(value) this.setCurrentUserRoleId(value.id)
            setTimeout(()=>{
                this.currentOrganization = get(this.userOrganizations, '0')
                if(this.currentOrganization) this.setCurrentOrganizationId(this.currentOrganization.id)
                this.currentPosition = get(this.userPositions, '0')
                if(this.currentPosition) this.setCurrentPositionId(this.currentPosition.id)
            }, 10)
        },
        organizationSelect(value) {
            if(value) this.setCurrentOrganizationId(value.id)
            setTimeout(()=>{
                this.currentPosition = get(this.userPositions, '0')
                if(this.currentPosition) this.setCurrentPositionId(this.currentPosition.id)
            }, 10)
        },
        positionSelect(value) {
            if(value) this.setCurrentPositionId(value.id)
        },
        roleToRoles(role) {
            switch (role) {
                case ENGINEER:
                    return [ENGINEER, STUDENT]
                default:
                    return [role]
            }
        },
        openOrgTooltip() {
            this.fetchOrganizationsIfNeeded()
        }
    },
    computed: {
        ...mapGetters({
            isSideBarOpen: 'e/pages/isSideBarOpen',
            currentUser: 'e/users/currentUser',
            currentUserRoleId: 'e/users/currentUserRoleId',
            currentPositionId: 'e/users/currentPositionId',
            currentOrganizationId: 'e/users/currentOrganizationId',
        }),
        userRoles () {
            let hasOne = uniq(map(get(this.currentUser, 'currentRoles', []), 'role.sysname')).length === 1
            return filter(this.filterItems('role', item => true), item => hasOne ? true : item.sysname !== STUDENT)
        },
        roleNames () {
            return map(this.userRoles, 'name').join(', ')
        },
        userOrganizations () {
            let role = get(this.currentRole, 'sysname')
            let roles = this.roleToRoles(role)
            return this.filterItems('organization', item => includes(roles, get(item, 'role.sysname')))
        },
        organizationFullPath () {
            return map(this.userOrganizations, org => {
                return org.parentPath()
            }).join(', ')
        },
        organizationNames () {
            return map(this.userOrganizations, 'name').join(', ')
        },
        userPositions () {
            let role = get(this.currentRole, 'sysname')
            let roles = this.roleToRoles(role)
            return this.filterItems('position', item => includes(roles, get(item, 'role.sysname')) && get(item, 'organization.id') === get(this.currentOrganization, 'id'))
        },
        positionNames () {
            return map(this.userPositions, 'name').join(', ')
        },
        isVisibleStudentMenu () {
            return get(this.currentUser, 'currentRoles', []).length !== 0
        },
        isVisibleEngineerMenu () {
            return get(this.currentUserRole, 'role.sysname') === ENGINEER
        },
        isVisibleAdminMenu () {
            return get(this.currentUserRole, 'role.sysname') === ADMIN
        },
        currentUserRole() {
            return find(this.currentUser.currentRoles, userRole => userRole.role.id === this.currentUserRoleId)
        },

        applicationLink () {
            return 'https://docs.google.com/forms/d/e/1FAIpQLSclC0gHQ8LrPESG1O7G3XKeWyWroI7AlF2SR6RrLNcSi4LnlQ/viewform?entry.1605215870=' +
                encodeURIComponent(this.$_get(this.currentUser, 'email'))
        },
        userProfileUrl () {
            return getUserProfileURL()
        },
    },
    watch: {
        userRoles: {
            deep: true,
            immediate: true,
            handler () {
                if (!this.currentUserRoleId) {
                    this.currentRole = get(this.userRoles, '0')
                }
            }
        },
        userPositions: {
            deep: true,
            immediate: true,
            handler () {
                if (!this.currentPositionId) {
                    this.currentPosition = get(this.userPositions, '0')
                }
            }
        },
        userOrganizations: {
            deep: true,
            immediate: true,
            handler () {
                if (!this.currentOrganizationId) {
                    this.currentOrganization = get(this.userOrganizations, '0')
                }
            }
        },
    }
}
</script>
